export const FETCH_DATA_PENDING = "FETCH_DATA_PENDING";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_UPDATE = "FETCH_DATA_UPDATE";
export const FETCH_HIERARCHY_DATA = "FETCH_HIERARCHY_DATA";
export const FETCH_TABLE_DATA = "FETCH_TABLE_DATA";
export const RESET_HIERARCHY_DATA = "RESET_HIERARCHY_DATA";
export const FETCH_DATA_ERROR = "FETCH_DATA_ERROR";
export const FETCH_STOCK_TABLE_DATA = "FETCH_STOCK_TABLE_DATA";
export const FETCH_SALES_TABLE_DATA = "FETCH_SALES_TABLE_DATA";
export const SHOW_HEADER = "SHOW_HEADER";
export const SHOW_SIDEBAR = "SHOW_SIDEBAR";
export const SET_PAYOUT_DASHBOARD = "SET_PAYOUT_DASHBOARD";
export const UNSET_PAYOUT_DASHBOARD = "UNSET_PAYOUT_DASHBOARD";
export const SET_CLAWBACK_DASHBOARD = "SET_CLAWBACK_DASHBOARD";
export const UNSET_CLAWBACK_DASHBOARD = "UNSET_CLAWBACK_DASHBOARD";

export function setPayoutDashboard() {
  return {
    type: SET_PAYOUT_DASHBOARD,
  };
}

export function unsetPayoutDashboard() {
  return {
    type: UNSET_PAYOUT_DASHBOARD,
  };
}

export function setClawbackDashboard() {
  return {
    type: SET_CLAWBACK_DASHBOARD,
  };
}

export function unsetClawbackDashboard() {
  return {
    type: UNSET_CLAWBACK_DASHBOARD,
  };
}

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING,
  };
}
export function triggerShowHeader(payload) {
  return {
    type: SHOW_HEADER,
    payload,
  };
}

export function triggerShowSidebar(payload) {
  return {
    type: SHOW_SIDEBAR,
    payload,
  };
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    payload: data,
  };
}

export function fetchDataUpdate(newData) {
  return {
    type: FETCH_DATA_UPDATE,
    payload: newData,
  };
}

export function fetchHierarchyData(data) {
  return {
    type: FETCH_HIERARCHY_DATA,
    payload: data,
  };
}

export function fetchTableData(endpoint, data) {
  return {
    type: FETCH_TABLE_DATA,
    payload: data,
    endpoint: endpoint,
  };
}

export function fetchStockTableData(endpoint, data) {
  return {
    type: FETCH_STOCK_TABLE_DATA,
    payload: data,
    endpoint: endpoint,
  };
}

export function fetchSalesTableData(endpoint, data) {
  return {
    type: FETCH_SALES_TABLE_DATA,
    payload: data,
    endpoint: endpoint,
  };
}

export function resetHierarchyData() {
  return {
    type: RESET_HIERARCHY_DATA,
  };
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error,
  };
}
